var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWindNorthEast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "48px",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#48484a",
    fillRule: "evenodd",
    id: "arrow-down-left",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5839749,19.7226499 L15.5434343,19.7953753 C15.3973068,20.1162383 15.6291771,20.5 16,20.5 L21.5,20.499 L21.5,39 C21.5,39.2761424 21.7238576,39.5 22,39.5 L26,39.5 L26.0898756,39.4919443 C26.3231248,39.4496084 26.5,39.2454599 26.5,39 L26.5,20.499 L32,20.5 C32.3993477,20.5 32.6375434,20.0549273 32.4160251,19.7226499 L24.4160251,7.7226499 C24.2181141,7.42578337 23.7818859,7.42578337 23.5839749,7.7226499 L15.5839749,19.7226499 Z",
    fill: "#000000",
    fillRule: "nonzero",
    id: "Path",
    transform: "translate(24.000000, 23.500000) scale(-1, -1) rotate(45.000000) translate(-24.000000, -23.500000) "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindNorthEast);
export default __webpack_public_path__ + "static/media/windNorthEast.7b336d4c43def8fa05fb1dc7601000ee.svg";
export { ForwardRef as ReactComponent };